import { DialogTitle, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import type { UploadReceiptHeaderProps } from '../../../types/uploadReceiptDialog';

const UploadReceiptHeader = ({ onClose }: UploadReceiptHeaderProps) => {
  return (
    <DialogTitle
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontWeight: 'bold',
        background: '#EEE8FF',
        color: '#222B45',
        mb:0.5
      }}
    >
      Upload Receipt for Audit
      <IconButton onClick={onClose} size="small">
        <Close sx={{ color: '#222B45' }} />
      </IconButton>
    </DialogTitle>
  );
};

export default UploadReceiptHeader;
